import { gql } from "@apollo/client";

export const GET_CATEGORY_INFO = gql`
  query getCategoryInfo($uid: String!) {
    categories(filters: { category_uid: { eq: $uid } }) {
      items {
        id
        uid
        name
        description
        children {
          id
          uid
          name
          description
          children {
            id
            uid
            name
            description
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const GET_ROOT_CATEGORY_ID = gql`
  query getRootCategoryId {
    storeConfig {
      store_code
      root_category_uid
      __typename
    }
  }
`;
